// extracted by mini-css-extract-plugin
export var brand = "_9o-9";
export var compact = "_9o-6";
export var extraSmall = "_9o-7";
export var icon = "_9o-0";
export var large = "_9o-4";
export var light = "_9o-1";
export var medium = "_9o-5";
export var outline = "_9o-b";
export var primaryDark = "_9o-a";
export var primaryLight = "_9o-8";
export var primaryModern = "_9o-c";
export var success = "_9o-2";
export var successSolid = "_9o-3";